var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfileMenuCross(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.828,
    height: 18.828,
    viewBox: "0 0 18.828 18.828",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C_12635",
    transform: "translate(-1045.086 -194.086)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "\\u041B\\u0438\\u043D\\u0438\\u044F_832",
    x2: 16,
    y2: 16,
    transform: "translate(1046.5 195.5)",
    fill: "none",
    stroke: "#9299a2",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "\\u041B\\u0438\\u043D\\u0438\\u044F_833",
    x1: 16,
    y2: 16,
    transform: "translate(1046.5 195.5)",
    fill: "none",
    stroke: "#9299a2",
    strokeLinecap: "round",
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileMenuCross);
export default __webpack_public_path__ + "static/media/profile-menu-cross.d81d85d54ecd95c8fba90ae9e4fa3198.svg";
export { ForwardRef as ReactComponent };